import {createAction, handleActions} from 'redux-actions';
import {ThunkAction} from 'redux-thunk';
import {RootState} from '../store';

const SET_COMPANY_INFO= '/SET_COMPANY_INFO';

export const globalCompanyInfoCreator = createAction(SET_COMPANY_INFO);

export function setGlobalCompanyInfo(data: any): ThunkAction<void, RootState, null, ReturnType<typeof globalCompanyInfoCreator>> {
    return async function (dispatch) {
    try {
      dispatch(globalCompanyInfoCreator({
        data: data
      }));
    } catch (error) {
      
    }
  };
}

export interface CompanyInfoState {
  "config_site_name": string,
  "config_company_name": string,
  "config_company_repre_name": string,
  "config_business_number": string,
  "c_config_business_name": string,
  "config_company_address": string,
  "config_private_info_name": string,
  "config_private_info_email": string,
  "config_company_email": string,
  "config_partner_company": string,
  "config_online_prev_approve_code": string,
  "config_company_call_number": string,
  "config_consultation_visible": string,
  "config_cs_call_number": string,
  "config_cs_open_time": string,
  "config_meta_tag": string,
  "company_icon_image_pc": string,
  "company_icon_image_mo": string,
  "company_icon_favicon": string,
  "config_mail_order_number": string,
}

const initialState: CompanyInfoState = {
  "config_site_name": "",
  "config_company_name": "",
  "config_company_repre_name": "",
  "config_business_number": "",
  "c_config_business_name": "",
  "config_company_address": "",
  "config_private_info_name": "",
  "config_private_info_email": "",
  "config_company_email": "",
  "config_partner_company": "",
  "config_online_prev_approve_code": "",
  "config_company_call_number": "",
  "config_consultation_visible": "0",
  "config_cs_call_number": "",
  "config_cs_open_time": "",
  "config_meta_tag": "",
  "company_icon_image_pc": "",
  "company_icon_image_mo": "",
  "company_icon_favicon": "",
  "config_mail_order_number": "",
};

export const globalCompanyInfo = handleActions<CompanyInfoState, any>({
  [SET_COMPANY_INFO]: (state, action: ReturnType<typeof globalCompanyInfoCreator>) => ({
    config_site_name: action.payload.data.config_site_name ?? state.config_site_name,
    config_company_name: action.payload.data.config_company_name ?? state.config_company_name,
    config_company_repre_name: action.payload.data.config_company_repre_name ?? state.config_company_repre_name,
    config_business_number: action.payload.data.config_business_number ?? state.config_business_number,
    c_config_business_name: action.payload.data.c_config_business_name ?? state.c_config_business_name,
    config_company_address: action.payload.data.config_company_address ?? state.config_company_address,
    config_private_info_name: action.payload.data.config_private_info_name ?? state.config_private_info_name,
    config_private_info_email: action.payload.data.config_private_info_email ?? state.config_private_info_email,
    config_company_email: action.payload.data.config_company_email ?? state.config_company_email,
    config_partner_company: action.payload.data.config_partner_company ?? state.config_partner_company,
    config_online_prev_approve_code: action.payload.data.config_online_prev_approve_code ?? state.config_online_prev_approve_code,
    config_company_call_number: action.payload.data.config_company_call_number ?? state.config_company_call_number,
    config_consultation_visible: action.payload.data.config_consultation_visible ?? state.config_consultation_visible,
    config_cs_call_number: action.payload.data.config_cs_call_number ?? state.config_cs_call_number,
    config_cs_open_time: action.payload.data.config_cs_open_time ?? state.config_cs_open_time,
    config_meta_tag: action.payload.data.config_meta_tag ?? state.config_meta_tag,
    company_icon_image_pc: action.payload.data.company_icon_image_pc ?? state.company_icon_image_pc,
    company_icon_image_mo: action.payload.data.company_icon_image_mo ?? state.company_icon_image_mo,
    company_icon_favicon: action.payload.data.company_icon_favicon ?? state.company_icon_favicon,
    config_mail_order_number: action.payload.data.config_mail_order_number ?? state.config_mail_order_number,
  }),
}, initialState);
